var _style, _defs, _defs2, _defs3, _defs4, _defs5, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOeBadge = function SvgOeBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "oe-badge_svg__Lag_1",
    x: 0,
    y: 0,
    viewBox: "0 0 53 47"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".oe-badge_svg__st6{fill:#004586}.oe-badge_svg__st7{font-family:\"OpenSans-Bold\"}.oe-badge_svg__st8{font-size:16.5668px}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oe-badge_svg__SVGID_1_",
    d: "M25.07 45.92.29 3.2C-.31 2.17.06.87 1.1.28 1.42.1 1.79 0 2.17 0h48.66C52.03 0 53 .96 53 2.14c0 .36-.09.72-.27 1.03L28.86 45.89c-.58 1.04-1.9 1.41-2.95.84a2.18 2.18 0 0 1-.84-.81"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "oe-badge_svg__SVGID_00000063633711522189481590000012533535324393390526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oe-badge_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#oe-badge_svg__SVGID_00000063633711522189481590000012533535324393390526_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oe-badge_svg__SVGID_00000042004311633339379240000011172905432640876460_",
    d: "M-.55 0h54.04v47.22H-.55z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "oe-badge_svg__SVGID_00000088096162689368682150000014602003030298878342_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oe-badge_svg__SVGID_00000042004311633339379240000011172905432640876460_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#oe-badge_svg__SVGID_00000088096162689368682150000014602003030298878342_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oe-badge_svg__SVGID_00000067931491014883977410000003940225251480840351_",
    d: "M-46.43-45.21H99.36V92.44H-46.43z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "oe-badge_svg__SVGID_00000116197507237567363240000012335895865251103417_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oe-badge_svg__SVGID_00000067931491014883977410000003940225251480840351_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#oe-badge_svg__SVGID_00000116197507237567363240000012335895865251103417_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oe-badge_svg__SVGID_00000083049163963732613040000012058074911585959604_",
    d: "M-.55 0h54.04v47.22H-.55z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "oe-badge_svg__SVGID_00000045604937250649560560000007443128364855091592_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oe-badge_svg__SVGID_00000083049163963732613040000012058074911585959604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.57-1H54.5v49.23H-1.57z",
    style: {
      clipPath: "url(#oe-badge_svg__SVGID_00000045604937250649560560000007443128364855091592_)",
      fill: "#e5ecf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.07 45.92.29 3.2C-.31 2.17.06.87 1.1.28 1.42.1 1.79 0 2.17 0h48.66C52.03 0 53 .96 53 2.14c0 .36-.09.72-.27 1.03L28.86 45.89c-.58 1.04-1.9 1.41-2.95.84a2.18 2.18 0 0 1-.84-.81z",
    style: {
      clipPath: "url(#oe-badge_svg__SVGID_00000045604937250649560560000007443128364855091592_)",
      fill: "none",
      stroke: "#004586",
      strokeWidth: 8.9062,
      strokeMiterlimit: 10
    }
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oe-badge_svg__SVGID_00000057864954376626783770000008782361786658611387_",
    d: "M7.6 6.72h37.86v17.61H7.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "oe-badge_svg__SVGID_00000153683508070288648340000004735396680992001173_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oe-badge_svg__SVGID_00000057864954376626783770000008782361786658611387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      clipPath: "url(#oe-badge_svg__SVGID_00000153683508070288648340000004735396680992001173_)"
    },
    transform: "matrix(1.008 0 0 1 15.473 19.523)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "oe-badge_svg__st6 oe-badge_svg__st7 oe-badge_svg__st8"
  }, "O")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 12.94,
    y: 0,
    className: "oe-badge_svg__st6 oe-badge_svg__st7 oe-badge_svg__st8"
  }, "E"))));
};
export { SvgOeBadge as ReactComponent };
export default __webpack_public_path__ + "ae11e4789de9f1e9d7cef31ec2fb37a0.svg";